import styled from "styled-components";

export const DateInputStyled = styled.div`
	margin-bottom: ${(props) => props.theme.space.xs};
`;
